import React from "react";
import useSmallNav from "../../../../hooks/useSmallNav";
import { Container } from "react-bootstrap";
import UnderlinedHeader from "../../../molecules/UnderlinedHeader/UnderlinedHeader";
import InfoHero from "../../../molecules/info/InfoHero/InfoHero";
import xclass from "../../../../assets/info/x-class-hero.jpg";
import InfoGrid from "../../../atoms/info/InfoGrid/InfoGrid";
import InfoHeader from "../../../atoms/info/InfoHeader/InfoHeader";
import InfoCard from "../../../molecules/info/InfoCard/InfoCard";
import InfoFooter from "../../../organisms/InfoFooter/InfoFooter";
import { popularVehicle } from "../../../../vars/popularVehicles";

const MercedesXClass = () => {
  useSmallNav("Mercedes X-Class");

  return (
    <section className={"popular"}>
      <Container>
        <UnderlinedHeader text={"Mercedes X-Class"} bolder />
        <InfoHero image={xclass} />
        <InfoGrid>
          <div>
            <InfoHeader
              text={
                "Czy jesteś posiadaczem Mercedesa X Klasy? Szukasz części zawieszenia lub ulepszeń zawieszenia?"
              }
            />
            <InfoHeader
              size="smaller"
              text={"Jeśli tak, to trafiłeś we właściwe miejsce."}
            />
            <p>
              Nowa X Klasa wprowadza Mercedesa na rynek pick-upów z napędem 4x4.
              I cóż to za wejście na rynek!
            </p>
            <p>
              Dzięki sprężynom śrubowym na obu osiach nowa Klasa X stanowi krok
              naprzód w porównaniu z bardziej tradycyjnymi pick-upami
              wyposażonymi w resory piórowe.
            </p>
            <p>
              Jednak w zależności od sposobu użytkowania pojazdu może okazać
              się, że zawieszenie wymaga modyfikacji lub ulepszenia.
            </p>
            <p>
              Oferujemy zestawy podnoszący do Twojej X Klasy, zapewniające
              bardziej agresywny wygląd i lepsze właściwości terenowe, a także
              zestawy do dużych obciążeń dla osób, które wykorzystują X Klasę do
              pracy w trudniejszych warunkach, przewożenia ciężkich ładunków i
              holowania ciężkiego sprzętu.
            </p>
            <p>
              Wszystkie nasze zestawy wyposażone są w amortyzatory Pedders Foam
              Cell, zapewniające najlepszą możliwą wydajność. Aby poznać
              szczegółowe informacje na temat tej technologii, zobacz film po
              prawej stronie.
            </p>
            <p>
              Nie wiesz, jakich zestawów lub części potrzebujesz? Skontaktuj się
              z nami, a ktoś z naszego zespołu będzie w stanie Ci pomóc.
            </p>
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/5F5cj3zCaCk"
              title={"Mercedes X-Class Video 1"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/-x9r6VqbGrg"
              title={"Mercedes X-Class Video 2"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/g1aSCo4S2_E"
              title={"Mercedes X-Class Video 3"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
          <div>
            {popularVehicle
              .find((e) => e.make === "Mercedes")
              .models.find((e) => e.display === "X-Class")
              .popular.map((item) => (
                <InfoCard
                  key={item.text}
                  name={item.text}
                  to={item.link}
                  photo={item.photo}
                />
              ))}
          </div>
        </InfoGrid>
        <InfoFooter make="Mercedes" model="X-Class" />
      </Container>
    </section>
  );
};

export default MercedesXClass;
